import React, { useState } from "react";
import Navbar from "../../components/Navbar";
import StepperComponent from "../../components/Stepper";
import { Outlet } from "react-router-dom";
import { useMediaQuery, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/types";

// Define the types for the props
interface KYBScreenProps {
  // Define any props if needed, currently none are being passed directly
}

const KYBScreen: React.FC<KYBScreenProps> = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeStep, setActiveStep] = useState<number>(0);
  const userData = useSelector((store: RootState) => store.user.loginUserDetails)

  const handleNext = (): void => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = (): void => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const isImpersonate = sessionStorage.getItem("isImpersonate")

  return (
    <div data-testid="kyb-screen" className="w-full bg-[#F8F8F8] h-[95vh]">
      {isImpersonate && <header className="bg-[#FF5c39] fixed z-[99999] w-[100%] text-white h-[33px] text-center items-center flex justify-center capitalize"> IMPERSONATING {userData?.ProfileName?.length > 2 ? userData?.ProfileName : userData?.BusinessAccounts?.[0]?.ProfileName || userData?.FirstName && userData?.LastName ? userData?.FirstName + " " + userData?.LastName : "" } </header>}

      <Navbar data-testid="navbar" />
      <main data-testid="main-content" className={` ${isImpersonate?'pt-28 sm:pt-36 md:pt-32 ':`pt-20 sm:pt-32 md:pt-24` } h-[85vh]`}>
        <StepperComponent data-testid="stepper" activeStep={activeStep} isMobile={isMobile} />
        <Outlet
          context={{
            handleNext,
            handleBack,
            setActiveStep,
            activeStep,
            isMobile,
          }}
        />
      </main>
    </div>
  );
};

export default KYBScreen;
